"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = exports.Heading = exports.Content = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Content = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	text-align: center;
`;
exports.Heading = styled_components_1.default.div `
	font-size: 1.4rem;
	font-weight: bold;
	margin-top: 1rem;
	margin-bottom: 3rem;
`;
exports.Message = styled_components_1.default.div `
	margin-bottom: 3rem;
`;
